// PredictedWindowChip — heads-up that the next 6 hours overlap a
// historically tough hour-of-week for this user. Renders as a thin
// accent-left chip with a chevron; tapping opens the urge-surf
// pre-phase.
//
// Extracted 2026-05-26 from TodayScreen.tsx (lines 1247-1277). The
// visibility predicate stays in TodayScreen — this component renders
// only when the parent decides to show it, and consumes the two
// prediction-window fields as scalar props.
//
// Why scalar props (not the whole window object): keeps the prop
// surface minimal and the test surface tight. Adding fields later is
// cheap; the component is a pure render of two strings.

import { Card } from '../ui/Card';

interface PredictedWindowChipProps {
  /** Local hour (0-23) of the predicted tough window. Rendered zero-padded. */
  hour: number;
  /** Human label for the day-of-week (e.g. "Monday afternoons"). */
  label: string;
  /** Fired when the chip is tapped — parent navigates to /app/urge?phase=pre&trigger=predicted_window. */
  onOpenUrgeSurf: () => void;
}

export function PredictedWindowChip({ hour, label, onOpenUrgeSurf }: PredictedWindowChipProps) {
  return (
    <Card className="predicted-window-chip" accentLeft>
      <button
        type="button"
        onClick={onOpenUrgeSurf}
        style={{
          inlineSize: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          background: 'transparent',
          border: 0,
          padding: 0,
          cursor: 'pointer',
          textAlign: 'start',
          color: 'inherit',
          font: 'inherit',
        }}
        aria-label="Open urge-surf pre-phase"
      >
        <span>
          Heads up — {String(hour).padStart(2, '0')}:00 has been tough on {label}.
        </span>
        <span
          aria-hidden="true"
          style={{ color: 'var(--color-ink-tertiary)', fontSize: 'var(--text-body-lg)' }}
        >
          ›
        </span>
      </button>
    </Card>
  );
}
